// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { SelectLanguageModal } from './select-language-modal'

const COMPONENT_ID = 'selectLanguage'

export const showCreateSelectLanguageModal = () =>
  addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: SelectLanguageModal,
  },
}
